import { useSyncStripePricing } from "@/hooks/useSyncStripePricing";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { RefreshCw } from "lucide-react";

export default function AdminSync() {
  const { syncPricing, loading, error } = useSyncStripePricing();

  const handleSync = async () => {
    try {
      await syncPricing();
      // Clear frontend cache
      sessionStorage.removeItem('stripe_pricing_cache');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (err) {
      // Sync failed
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Stripe Pricing Sync</CardTitle>
          <CardDescription>
            Sync pricing data from Stripe to Supabase database
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleSync} 
            disabled={loading}
            className="w-full"
            size="lg"
          >
            {loading ? (
              <>
                <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
                Syncing...
              </>
            ) : (
              <>
                <RefreshCw className="mr-2 h-4 w-4" />
                Sync Stripe Prices
              </>
            )}
          </Button>
          {error && (
            <div className="text-sm text-destructive">
              Error: {error}
            </div>
          )}
          <div className="text-sm text-muted-foreground">
            This will fetch the latest products and prices from Stripe and update the database.
            Only prices with <code className="bg-muted px-1 rounded">public_price: true</code> metadata will be synced for courses.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
